import React, { ReactNode } from 'react';
import { childrenIdMatch } from '../utils';

export const filterChildrenByType = (children: ReactNode, id: string) =>
    React.Children.toArray(children).filter((child) => childrenIdMatch(child, id));
